import { render, staticRenderFns } from "./serviceForecast.vue?vue&type=template&id=24cf524b"
import script from "./serviceForecast.vue?vue&type=script&lang=js"
export * from "./serviceForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports